import React from 'react';
import { motion } from 'framer-motion';
export function ProductIntro() {
  return <section className="w-full bg-blush px-5 py-12 sm:py-20" data-id="element-180" data-mp="22lezoe7p17k6">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.3
    }} transition={{
      duration: 0.5
    }} className="mx-auto flex max-w-2xl flex-col items-center text-center" data-id="element-181" data-mp="22mq66lsiwtez">
        <span className="mb-5 inline-block rounded-full border border-primary/40 bg-surface px-4 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-primary-strong" data-id="element-182" data-mp="2ge4t33pjxerb">
          Lo que incluye el método
        </span>
        <h2 className="font-display text-3xl font-bold leading-tight text-foreground sm:text-5xl" data-id="element-183" data-mp="26kxmxgmzluq6">
          Aprende Coreano Fácil™: <span className="text-pink" data-id="element-184" data-mp="2zbxt9y8sjal0">Método Visual</span> desde Cero
        </h2>
        <p className="mt-5 text-base font-medium text-primary-strong sm:text-lg" data-id="element-185" data-mp="2z9utwnlr053m">
          El método visual para empezar a entender coreano aunque nunca hayas estudiado un idioma.
        </p>
        <div className="mx-auto mt-6 h-px w-16 bg-primary/40" data-id="element-186" data-mp="udkp2kuh63m2" />
        <p className="mt-6 text-sm leading-relaxed text-muted sm:text-base" data-id="element-187" data-mp="phwx5xolywcv">
          6 módulos organizados paso a paso, más 4 bonos y más de 100 fichas visuales para repasar.
          Diseñado para que cada día de estudio te acerque a leer, pronunciar y usar coreano real.
        </p>
      </motion.div>
    </section>;
}